import { type BaseTicketComment } from "@mg/schemas/src/christo/catalyst";
import { Prohibit, Warning } from "@phosphor-icons/react";

interface ImageCommentPinProps {
  comment: BaseTicketComment;
  isActive: boolean;
  onPinClick: (comment: BaseTicketComment) => void;
}

export function ImageCommentPin({
  comment,
  isActive,
  onPinClick,
}: ImageCommentPinProps) {
  const relX = comment.rel_x;
  const relY = comment.rel_y;
  if (relX == null || relY == null) return null;

  const Icon = comment.isRequired ? Prohibit : Warning;
  const innerBg = comment.isRequired ? "bg-puntt-red-9" : "bg-puntt-gold-10";

  return (
    <button
      type="button"
      data-testid="comment-pin"
      data-comment-id={comment._id}
      data-required={comment.isRequired ?? false}
      onClick={(e) => {
        e.stopPropagation();
        onPinClick(comment);
      }}
      className="absolute z-20 cursor-pointer border-none bg-transparent p-0"
      style={{
        left: `${relX * 100}%`,
        top: `${relY * 100}%`,
      }}
      title={comment.description?.slice(0, 80)}
    >
      <div
        className={`rounded-t-2xl rounded-br-2xl p-0.5 shadow-md transition-all duration-150 ${
          isActive
            ? "bg-puntt-accent-9 ring-2 ring-puntt-accent-9/50 ring-offset-1"
            : "bg-puntt-red-9"
        }`}
        style={{
          transform: `translateY(-100%) rotate(-45deg) ${isActive ? "scale(1.35)" : "scale(1)"}`,
          transformOrigin: "0% 100%",
        }}
      >
        <div
          className={`flex size-6 items-center justify-center rounded-full ${
            isActive ? "bg-puntt-accent-9" : innerBg
          }`}
          style={{ transform: "rotate(45deg)" }}
        >
          <Icon size={14} weight="fill" className="text-base-white" />
        </div>
      </div>
    </button>
  );
}
